import list from './lists/list';
import calendar from './lists/calendar';

export default {
    namespaced: true,
    state: () => ({
        avaibleStatuses:{
            event_reserved: {
                text: "Зарезервирован",
                style: {
                    'background-color': "#FAA61A"
                }
            },
            event_free: {
                text: "Свободно",
                style: {
                    'background-color': "#43B581"
                }
            },
            event_planned: {
                text: "Занято",
                style: {
                    'background-color': "#ff0000"
                }
            }
        }
    }),
    mutations: {
    },
    getters: {
        GetAvaibleStatuses: (s) => s.avaibleStatuses,
    },
    modules: {
        list,
        calendar
    }
}